import StandardQueryTable from "@/components/StandardQueryTable";
import { PATH_DICTS_SHIFTS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import ShiftCreator from "@/modules/shifts/components/ShiftCreator";
import ShiftEditor from "@/modules/shifts/components/ShiftEditor";
import { ShiftsService } from "@/modules/shifts/service";
import { readShiftListItem, writeShift } from "@/schemas/shift";
import { ReadShift, ReadShiftListItem, WriteShift } from "@/types/shift";
import { Replace } from "lucide-react";

const id = Module.Shifts;
const path = PATH_DICTS_SHIFTS;
const ns = "shifts";

const config: DictionaryConfig<ReadShift, WriteShift> = {
  id,
  ns,
  service: ShiftsService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeShift,
  defaultValues: {
    name: "",
    description: "",
    shift_begin: "",
    shift_end: "",
    mandatory: false,
  },
  Icon: Replace,
  List: () => (
    <StandardQueryTable<ReadShiftListItem>
      schema={readShiftListItem}
      name={ns}
      fetchList={ShiftsService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.Shifts },
      }}
    />
  ),
  Creator: ShiftCreator,
  Editor: ShiftEditor,
};

export default config;
